<template>
  <header class="main-header" :style="myBgColorStyle">
    <div class="content-wrapper">
      <div class="row">
        <div class="col-xs-2 col-md-6 header-controls">
          <div class="header-item-left header-item-left-menu">
            <div class="menu-img">
              <i class="scf-suez-logo"></i>
            </div>
          </div>
          <div
            class="header-item-left header-item-left-menu"
            style="padding-left: 20px"
          >
            <header-info-box
              v-if="data.length"
              :collapsed="true"
              :items="data"
              :heightSize="'44px'"
              :leftIcon="{ class: 'scf-organization', styles: 'color:#aadc14' }"
              :rightIcon="{
                class: 'scf-edit',
                styles: 'color:#aadc14;cursor: pointer;',
              }"
              @clickEvent="test"
            ></header-info-box>
          </div>
        </div>

        <div class="col-xs-6 col-md-6 header-links">
          <div class="hidden-xs">
            <div class="header-item menu-header-separator unselectable-text">
              <span :style="myTxtColorStyle" v-on:click="logout">
                <i class="scf-logout"></i>
              </span>
            </div>

            <div class="header-item unselectable-text-username">
              <i class="scf-user"></i>
            </div>
            <div class="header-item unselectable-text-username">
              {{ this.loggedInUser !== null ? this.loggedInUser.name : "" }}
            </div>
            <div class="header-item menu-header-separator"></div>
            <div class="header-item unselectable-text">
              <slot name="languageSwitcher"></slot>
            </div>
            <div class="header-item menu-header-separator"></div>
            <div class="header-item unselectable-text">
              <slot name="searchBar"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PerimeterModal
      v-if="this.preselectedScope && clientData && clientData.length > 0"
      :isShowModal="showModal"
      :headerTitle="$t('navbar.modalTitle')"
      :clientComboLabel="'CLIENT'"
      :clients="clientData"
      v-model:projects="projects"
      :labels="{ cancel: 'Cancel', save: 'Confirm' }"
      :onItemChanged="handleChangeScope"
      :onCheckedItemsChanged="handleSetContext"
      :selectedIndex="selectedIndex"
      :preselectedScope="this.preselectedScope"
      @Cancel="cancelModal"
      @validate="setData"
    />
  </header>
</template>

<script>
import { computed } from "vue";
import { useStore, mapState } from "vuex";

import headerInfoBox from "@/components/atoms/HeaderInfoBox.vue";
import PerimeterModal from "@/components/atoms/PerimeterModal.vue";

import ScopeService from "@/_services/ScopeService";
import ClientService from "@/_services/ClientService";
import ScopeHelper from "@/_helpers/ScopeHelper";

export default {
  name: "nav-bar",
  components: {
    headerInfoBox,
    PerimeterModal,
  },
  inject: ["loggedInUser", "lang", "appsLoaded"],
  setup() {
    const store = useStore();
    const keycloak = computed(() => store.state.keycloakInstance);
    return {
      keycloak,
    };
  },
  watch: {
    appsLoaded(newVal) {
      if (newVal) this.loadScops();
    },
    tmpData(newVal) {
      if (newVal.length > 1) {
        this.dataIsSet = true;
        this.showModal = true;
      }
    },
    token(newVal) {
      if (newVal) {
        this.scopeService = new ScopeService(newVal, this.currentScope);
        this.clientService = new ClientService(newVal, this.currentScope);
      }
    },
    showModal(newVal) {
      if (newVal) {
        this.oldProjects = this.projects;
        this.oldSelectedIndex = this.selectedIndex;
      }
    },
  },
  data() {
    return {
      oldProjects: [],
      showModal: false,
      isScopeFromRoute: false,
      preselectedScope: this.userPreselectedScopes(),
      scopeService: new ScopeService(this.$jwt.token, this.$jwt.scope),
      clientService: new ClientService(this.$jwt.token, this.$jwt.scope),

      currentScope: null,
      routeScope: null,

      collapsed: true,
      dataIsSet: false,
      tmpData: [],
      data: [],
      ScopesNames: [],
      myData: [],

      clientData: [],
      projects: [],
      errorMessage: null,
      selectedIndex: -1,
      oldSelectedIndex: -1,
      tmpSelectedIndex: null,
    };
  },
  methods: {
    updateIndex() {
      this.selectedIndex = this.tmpSelectedIndex;
    },
    logout() {
      this.keycloak.logout({
        redirectUri: window.location.origin + "/" + this.$realm + "/home",
      });
    },
    isObject: function (value) {
      if (value && typeof value === "object") return true;

      return false;
    },
    findObject: function (object = {}, keyToMatch = "", valueToMatch = "") {
      let self = this;
      if (self.isObject(object)) {
        const entries = Object.entries(object);

        for (let i = 0; i < entries.length; i += 1) {
          const [objectKey, objectValue] = entries[i];

          if (objectKey === keyToMatch && objectValue === valueToMatch) {
            return object;
          }

          if (self.isObject(objectValue)) {
            const child = self.findObject(
              objectValue,
              keyToMatch,
              valueToMatch
            );

            if (child !== null) {
              return child;
            }
          }
        }
      }

      return null;
    },
    getScopeName: function (scopeValue) {
      const match = this.findObject(this.tmpData, "scope", scopeValue);

      return match
        ? match.name //: "";
        : this.ScopesNames.find((e) => e.scope == scopeValue) != null
        ? this.ScopesNames.find((e) => e.scope == scopeValue).name
        : "Aucun périmètre selectionné.";
    },
    getLevelsScope: function (scope) {
      let levelScope = [];

      if (scope.length == 1) return scope;
      let i = scope[0] + "." + scope[1];
      levelScope.push(scope[0] + "." + scope[1]);
      for (let index = 2; index < scope.length; index++) {
        i += "." + scope[index];
        levelScope[index - 1] = i;
      }

      return levelScope;
    },
    Init(scopeArray, levels) {
      let x = Object.entries(levels).map((el) => {
        return {
          key: el[1],
          value: [],
        };
      });
      var scopeList = [];
      for (let index = 0; index < scopeArray.length; index++) {
        scopeList.push(this.getLevelsScope(scopeArray[index].split(".")));
      }

      for (let index = 0; index < scopeList.length; index++) {
        for (let j = 0; j < scopeList[index].length; j++) {
          if (j < levels.length) x[j].value.push(scopeList[index][j]);
        }
      }

      let y = Object.entries(x).map((el) => {
        return {
          key: el[1].key,
          value: [
            ...new Set(el[1].value.map((name) => this.getScopeName(name))),
          ],
        };
      });
      this.data = y;
      this.dataIsSet = true;
    },
    cancelModal(data) {
      this.data = data;
      this.showModal = false;
      this.projects = this.oldProjects;
      this.selectedIndex = this.oldSelectedIndex;
    },
    setData(datatoSet) {
      this.showModal = false;
      const event = new CustomEvent("ContextChanged", {
        detail: {
          ...datatoSet,
        },
      });
      const scopesToSave =
        datatoSet.scopes && datatoSet.scopes.length > 0
          ? datatoSet.scopes
          : [datatoSet.client.scope];
      ScopeHelper.saveSelectedScopes(this.loggedInUser, scopesToSave);
      window.dispatchEvent(event);
    },
    test() {
      this.showModal = true;
      this.updateIndex();
    },
    getHirarchiesLine(data) {
      if (data) {
        return data
          .filter((w) => w.value.length)
          .map((elem) => ({
            key: elem.key,
            value: elem.value.join(","),
          }))
          .map((x) => x.value)
          .join(" > ");
      } else return "";
    },
    getScopeLevel(node) {
      if (!node.children || node.children.length === 0)
        return node.scope.split(".").length - 1;

      const childrenScopes = node.children.map((child) =>
        this.getScopeLevel(child)
      );
      const longestScope = childrenScopes.reduce(
        (a, b) => (a.length > b.length ? a : b),
        ""
      );

      return longestScope;
    },
    async handleChangeScope(result) {
      try {
        this.tmpSelectedIndex = result.selectedIndex;
        this.currentScope = result.selectedValue.scope;

        this.scopeService = new ScopeService(this.token, this.currentScope);

        this.clientService = new ClientService(this.token, this.currentScope);
        this.projects = await this.scopeService.GetHierarchyByScope(
          result.selectedValue.scope
        );
        this.data = result.checkedItem;
      } catch (e) {
        console.warn(e);
      }
    },
    handleSetContext(s) {
      this.data = s;
    },
    extractScopePath(path) {
      // Split the path by '/'
      const segments = path.split("/");

      // Find the index of the segment that starts with 'ALL'
      let scope = null;
      segments.forEach((segment) => {
        if (segment.startsWith("ALL")) scope = segment;
      });
      return scope;
    },
    loadScops() {
      if (!this.$isDmApiMode) {
        this.clientData = [];
        return;
      }
      try {
        this.clientService.GetFromUser().then((clientData) => {
          this.clientData = clientData;

          if (this.clientData.length > 1) {
            this.showModal = true;
          }
          this.preselectedScope = this.userPreselectedScopes();
        });
      } catch (e) {
        console.warn(e);
      }
    },
    containsAny(arr1, arr2) {
      // Check if there is any common element between the two arrays
      return arr1.some((element) => arr2.includes(element));
    },
    userPreselectedScopes() {
      if (this.loggedInUser == null || !this.clientData) return null;
      if (this.isScopeFromRoute) {
        ScopeHelper.saveSelectedScopes(this.loggedInUser, this.routeScope);
      }
      const clientsScopes = this.clientData.map((cld) => cld.scope);
      let lsScopes = ScopeHelper.getUserSelectedScopes(this.loggedInUser);

      const filteredLsScopes = lsScopes?.filter(
        (ls) => clientsScopes.filter((cl) => ls.startsWith(cl)).length > 0
      );
      if (!this.arraysEqualUnordered(filteredLsScopes, lsScopes)) {
        ScopeHelper.saveSelectedScopes(this.loggedInUser, filteredLsScopes);
        lsScopes = filteredLsScopes;
      }

      if (lsScopes && lsScopes.length > 0) {
        const accessibleScopes = ScopeHelper.getUserAccessibleScopes(
          this.$jwt.scope,
          lsScopes
        );
        if (accessibleScopes == null) {
          this.redirectToNoScopesPage(401);
          return null;
        }
        if (accessibleScopes.length == 1 && accessibleScopes[0] == "ALL")
          return [];
        if (this.arraysEqualUnordered(accessibleScopes, lsScopes))
          return lsScopes;
        else {
          if (
            this.isScopeFromRoute &&
            !this.containsAny(accessibleScopes, this.routeScope)
          ) {
            this.redirectToNoScopesPage(401);
          }
          ScopeHelper.saveSelectedScopes(this.loggedInUser, accessibleScopes);
          return accessibleScopes;
        }
      } else {
        return this.preselectScopeBasedOnAuthorized();
      }
    },
    preselectScopeBasedOnAuthorized() {
      const authorizedScopes = this.$jwt.scope;
      if (!authorizedScopes || authorizedScopes.length == 0) {
        this.redirectToNoScopesPage();
        return null;
      }
      if (authorizedScopes.includes("ALL"))
        return []; // has access to ALL => nothing to preselect
      else if (authorizedScopes.length == 1)
        return authorizedScopes; // has access to one scope => preselect it
      else return []; // has access to many scopes: let the user choose
    },
    redirectToNoScopesPage(code = 499) {
      this.$router.replace({
        name: "error",
        params: { code: code },
      });
    },
    arraysEqualUnordered(array1, array2) {
      if ((!array1 && array2) || (array1 && !array2)) return false;
      if (!array1 && !array2) return true;

      const sorted1 = array1.slice().sort();
      const sorted2 = array2.slice().sort();

      return this.arraysEqual(sorted1, sorted2);
    },
    arraysEqual(array1, array2) {
      if (array1.length !== array2.length) {
        return false;
      }
      for (let i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) {
          return false;
        }
      }
      return true;
    },
  },
  computed: {
    myBgColorStyle: function () {
      return {
        backgroundColor: "#030f40",
      };
    },
    myTxtColorStyle: function () {
      return {
        color: "#D95D2C",
      };
    },
    logoSrc: function () {
      return null;
    },
    ...mapState(["token"]),
  },
  created() {
    let routeScope = this.extractScopePath(this.$route.path);
    if (routeScope && routeScope !== "") {
      this.isScopeFromRoute = true;
      this.routeScope = routeScope.split(",");
    }
  },
};
</script>

<style scoped>
.unselectable-text {
  user-select: none;
  cursor: pointer;
}

.unselectable-text-username {
  user-select: none;
}

header.main-header {
  /* float: left; */
  width: 100%;
  background: #030f40;
  font-family: "DINProM", "ropaSanRegular", sans-serif;
  color: #fff;
  min-width: 320px;
  height: 50px;
  padding-left: 15px;
  padding-right: 15px;
  box-shadow: 0px 4px 4px #fff;
  font-size: 15px;
  /* position: fixed; */
  /* z-index: 0.1; */
}

header.main-header div.container-fluid .header-links {
  text-align: right;
}

header ul.inline li {
  display: inline-block;
  padding: 0 5px;
}

.main-header .row {
  margin-right: 0px;
  margin-left: 0px;
}

.header-item {
  text-align: center;
  width: auto;
  float: right;
  height: 24px;
  line-height: 24px;
  margin-top: 12px;
  padding-right: 10px;
}

.header-item-left {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-block;
  float: left;
}

.header-item-left-menu {
  margin-right: 15px;
}

.header-item select {
  width: auto;
  display: inline;
}

.header-item a,
.header-item a:hover {
  color: #fff;
  text-decoration: inherit;
}

.header-logo {
  margin-top: 10px;
  width: 150px;
}

.menu-img {
  height: 50px;
  display: table-cell;
  vertical-align: middle;
}

.menu-header-separator {
  border-left: 1px solid #3d466c;
  padding-left: 11px;
}

.me-2 {
  height: 25px;
}
</style>
